
import {Controller} from './Controller';
import {HavenAnalytics} from '../../../common/js/HavenAnalytics';
import RemoteObjectTemplate from '@haventech/semotus';
import { amorphicStatic } from '@haventech/amorphic';

import jquery from 'jquery';


window['nconf'] = {
    Provider: function () {
        return {
            argv: function () {
                return {
                    env: function() {}
                };
            },
            get: function() {},
            set: function() {},
            file: function() {}
        };
    }
};

window['googleapis'] = {
    drive: function () {
        return {};
    }
};

window['$'] = jquery as unknown as JQueryStatic;
window['RemoteObjectTemplate'] = RemoteObjectTemplate;
window['amorphicStatic'] = amorphicStatic;
window['Controller'] = Controller;
window['HavenAnalytics'] = HavenAnalytics;